<div class="line-vertical" *ngIf="showLine">

</div>

<div class="line-horizontal" *ngIf="showLine" [style.background]="customColor || null">

</div>
